var React = require('react');

function Gh (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#006b3f","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#fcd116","d":"M0 0h640v320H0z","key":1}),React.createElement("path",{"fill":"#ce1126","d":"M0 0h640v160H0z","key":2}),React.createElement("path",{"d":"M320 160l52 160-136.1-98.9H404L268 320z","key":3})]);
}

Gh.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Gh;

Gh.default = Gh;
